import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../config/config";
import toast from "react-hot-toast";


export const fetchVisitorRequests = createAsyncThunk(
    "visitor/fetchVisitorRequests",
    async (_, { rejectWithValue }) => {
        try {
            const response = await API.GET(`/visiting-requests`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const updateVisitorRequestStatus = createAsyncThunk(
    "visitor/updateVisitorRequestStatus",
    async ({ requestId, status }: any, { rejectWithValue }) => {
        try {
            await API.PUT(`/visiting-requests/${requestId}`, { status });
            toast.success("Visitor request status updated successfully");
            return { requestId, status };
        } catch (error: any) {
            toast.error("Error updating visitor request status");
            return rejectWithValue(error.response.data);
        }
    }
);

const visitorSlice = createSlice({
    name: "visitor",
    initialState: {
        visitorRequests: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVisitorRequests.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVisitorRequests.fulfilled, (state, action) => {
                state.loading = false;
                state.visitorRequests = action.payload;
            })
            .addCase(fetchVisitorRequests.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as any;
            })
            .addCase(updateVisitorRequestStatus.fulfilled, (state, action) => {
                const { requestId, status } = action.payload;
                const request: any = state.visitorRequests.find((req: any) => req._id === requestId);
                if (request) request.status = status;
            });
    },
});

export default visitorSlice.reducer;
